import React, { FC, PropsWithChildren } from 'react';
import { Tooltip2, Tooltip2Props } from '@blueprintjs/popover2';

const Tooltip: FC<PropsWithChildren<Omit<Tooltip2Props, 'content'> & { content?: JSX.Element | string }>> = ({
  children,
  content = '',
  ...props
}) => (
  <Tooltip2 {...{ ...props, content }} openOnTargetFocus={false}>
    {children}
  </Tooltip2>
);

export default Tooltip;
